import { render } from "./GuideAccordion.vue?vue&type=template&id=610217dc"
import script from "./GuideAccordion.vue?vue&type=script&lang=js"
export * from "./GuideAccordion.vue?vue&type=script&lang=js"

import "./GuideAccordion.vue?vue&type=style&index=0&id=610217dc&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__